import type { CustomToolStep } from '@/types/custom-tool.types';
import { useCustomToolBuilder } from '../builder/builder-context';

/** A step as the builder names it, by its place and its tool: "2. Get Shopify order". */
export const useStepName = () => {
	const { draft, stepTools } = useCustomToolBuilder();
	return (step: CustomToolStep): string => `${draft.steps.indexOf(step) + 1}. ${stepTools.toolFor(step)?.label ?? step.tool}`;
};
